import React from 'react';
import styled from 'styled-components';

const SiteKitContentWrapper = styled.main`
  max-height: 100vh;
  max-width: 100%;
  min-height: 100%;
  overflow-y: auto;
`;

interface SiteKitContentProps {
  children: React.ReactNode;
}

const SiteKitContent = ({ children }: SiteKitContentProps) => (
  <SiteKitContentWrapper role="main" id="main" tabIndex={-1}>
    {children}
  </SiteKitContentWrapper>
);

SiteKitContent.displayName = 'SiteKit.Content';

export { SiteKitContent, SiteKitContentProps };
